import { Alert, Box, useMediaQuery, useTheme } from "@mui/material";
import AdvancedReportDataProvider from "features/reports/AdvancedReport/AdvancedReportDataProvider";
import AdvancedReportHeader from "features/reports/AdvancedReport/AdvancedReportHeader";
import AdvancedReportProvider from "features/reports/AdvancedReport/AdvancedReportProvider";
import AdvancedReportChart from "features/reports/AdvancedReport/components/AdvancedReportChart";
import AdvancedReportPivotTable from "features/reports/AdvancedReport/components/AdvancedReportPivotTable";
import AdvancedReportToolbar from "features/reports/AdvancedReport/components/AdvancedReportToolbar";
import I18n from "i18n";
import DynamicPricingReportFilter from "./DynamicPricingReportFilter";

export default function DynamicPricingReport() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AdvancedReportDataProvider
      visibleValues={["dynamic_price_diff"]}
      visibleFilters={["partners", "partnerGroups", "boats", "programs"]}
      fixedFilter={{ isGroup: false, excludeRebooked: true }}
      dateType="travel"
    >
      <AdvancedReportHeader title={I18n.t("DynamicPricingReport.title")} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          ml: isMobile ? -3 : 0,
          mr: isMobile ? -3 : 0,
          "& .MuiPaper-root": {
            borderRadius: isMobile ? 0 : undefined,
          },
        }}
      >
        <AdvancedReportProvider
          dateType="travel"
          chartType="bar"
          value="dynamic_price_diff"
        >
          <DynamicPricingReportFilter />
          <Alert severity="info">
            {I18n.t("DynamicPricingReport.exclusionNote")}
          </Alert>
          <AdvancedReportToolbar />
          <AdvancedReportChart />
          <AdvancedReportPivotTable />
        </AdvancedReportProvider>
      </Box>
    </AdvancedReportDataProvider>
  );
}
